import { UnitSystem } from '@trackman/baseball-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import { StrikeZoneLocation } from 'interfaces/session/IStrikeZoneDefinition';
import { StrikeZoneCalculationInformations } from 'interfaces/team/IApiScheduleResponse';
import { useInjection } from 'services/ioc/ioc.react';
import { unitConverters } from 'services/unitConverters';
import { LineupStore } from 'stores/LineupStore';

export function useHomePlate() {
  const lineupStore = useInjection<LineupStore>(ServiceTypes.LineupStore);

  const getOffsetValue = (calculation: StrikeZoneCalculationInformations) => {
    if (lineupStore.metrics === UnitSystem.Imperial) {
      return `${unitConverters.getValue(calculation.offset, lineupStore.metrics)} in`;
    }

    return `${unitConverters.getValue(calculation.offset, lineupStore.metrics)} cm`;
  };

  const getExtensionValue = (calculation: StrikeZoneCalculationInformations) => {
    if (lineupStore.metrics === UnitSystem.Imperial) {
      return `${unitConverters.getValue(calculation.extension, lineupStore.metrics)} in`;
    }

    return `${unitConverters.getValue(calculation.extension, lineupStore.metrics)} cm`;
  };

  const getDescription = () => {
    const calculations = lineupStore.league.strikeZoneCalculationInformations;

    if (!calculations || calculations.length === 0) {
      return;
    }

    const singleTextMap = {
      Front: 'front',
      Middle: 'middle',
      Back: 'back',
    };

    if (calculations.length === 1 && calculations[0].strikeZoneCalculationType) {
      return `The ${singleTextMap[calculations[0].strikeZoneCalculationType]} section of the home plate determine pitches.`;
    }

    if (calculations.length > 1) {
      const calculationTypes = calculations.map((calculation) => calculation.strikeZoneCalculationType);
      const typeSet = new Set(calculationTypes);

      if (typeSet.size === 2) {
        if (typeSet.has(StrikeZoneLocation.Front) && typeSet.has(StrikeZoneLocation.Middle)) {
          return 'The front and middle sections of the home plate determine pitches.';
        }
        if (typeSet.has(StrikeZoneLocation.Front) && typeSet.has(StrikeZoneLocation.Back)) {
          return 'The front and back sections of the home plate determine pitches.';
        }
        if (typeSet.has(StrikeZoneLocation.Middle) && typeSet.has(StrikeZoneLocation.Back)) {
          return 'The middle and back sections of the home plate determine pitches.';
        }
      }

      return 'All three sections of the home plate determine pitches.';
    }
  };

  return { getOffsetValue, getDescription, getExtensionValue };
}
